import { render, staticRenderFns } from "./IconsSection.vue?vue&type=template&id=73c05f8e&"
import script from "./IconsSection.vue?vue&type=script&lang=js&"
export * from "./IconsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports